window.price = function(value) {
  return value.toLocaleString(undefined, { style: "currency", currency: "EUR" })
}
